interface Config {
	NODE_ENV: 'development' | 'production';
	APIM_BASE_URL: string;
	APIM_KEY: string;
	DEV_SERVER_PORT: number;
	REACT_APP_API_KEY: string;
	COMPANY_API_URL: string;
	INSTRUMENT_API_URL: string;
	STREAMING_API_URL: string;
	STREAMING_API_KEY: string;
}

const requiredEnvVars = ['APIM_BASE_URL', 'APIM_KEY'] as const;

function validateConfig(config: Config): void {
	const missingVars = requiredEnvVars.filter(envVar => !config[envVar]);

	if (missingVars.length > 0) {
		throw new Error(`Missing required environment variables: ${missingVars.join(', ')}`);
	}

	// Additional validations
	if (config.APIM_BASE_URL && !config.APIM_BASE_URL.startsWith('http')) {
		throw new Error('APIM_BASE_URL must be a valid URL starting with http:// or https://');
	}

	if (config.DEV_SERVER_PORT && (isNaN(config.DEV_SERVER_PORT) || config.DEV_SERVER_PORT <= 0)) {
		throw new Error('DEV_SERVER_PORT must be a positive number');
	}
}

export const config: Config = {
	NODE_ENV: (process.env.NODE_ENV as 'development' | 'production') || 'development',
	APIM_BASE_URL: process.env.APIM_BASE_URL || '',
	COMPANY_API_URL: process.env.COMPANY_API_URL || '',
	INSTRUMENT_API_URL: process.env.INSTRUMENT_API_URL || '',
	APIM_KEY: process.env.APIM_KEY || '',
	DEV_SERVER_PORT: Number(process.env.npm_package_config_dev_server_port) || 3000,
	REACT_APP_API_KEY: process.env.REACT_APP_API_KEY || '',
	STREAMING_API_URL: process.env.STREAMING_API_URL || '',
	STREAMING_API_KEY: process.env.STREAMING_API_KEY || '',
};

// Validate the config object
validateConfig(config);

export default config;
